export default __webpack_public_path__ + "static/media/Horne FL 8.fc2451b4.JPEG";